import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './AuthContext';
import Navigation from './components/Navigation';
import PrivateRoute from './components/PrivateRoute';
import Landing from './components/Landing';
import Login from './components/Login';
import Register from './components/Register';
import AcceptInvitation from './components/AcceptInvitation';
import ForgotPassword from './components/ForgotPassword';
import ResetPassword from './components/ResetPassword';
import Waitlist from './components/Waitlist';
import GroupList from './components/GroupList';
import GroupDetail from './components/GroupDetail';
import JoinGroup from './components/JoinGroup';
import WishList from './components/WishList';
import AdminWaitlist from './components/AdminWaitlist';
import TermsOfService from './components/TermsOfService';
import PrivacyPolicy from './components/PrivacyPolicy';
import './App.css';

function AppRoutes() {
  return (
    <div className="App">
      <Navigation />
      <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/invite/:token" element={<AcceptInvitation />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password/:token" element={<ResetPassword />} />
            <Route path="/waitlist" element={<Waitlist />} />
            <Route path="/legal/terms" element={<TermsOfService />} />
            <Route path="/legal/privacy" element={<PrivacyPolicy />} />
            <Route
              path="/admin/waitlist"
              element={
                <PrivateRoute requireAdmin={true}>
                  <AdminWaitlist />
                </PrivateRoute>
              }
            />
            <Route path="/join/:inviteCode" element={<JoinGroup />} />
            <Route
              path="/groups"
              element={
                <PrivateRoute>
                  <GroupList />
                </PrivateRoute>
              }
            />
            <Route
              path="/groups/:groupId"
              element={
                <PrivateRoute>
                  <GroupDetail />
                </PrivateRoute>
              }
            />
            <Route
              path="/wishlist"
              element={
                <PrivateRoute>
                  <WishList />
                </PrivateRoute>
              }
            />
      </Routes>
    </div>
  );
}

function App() {
  return (
    <AuthProvider>
      <Router>
        <AppRoutes />
      </Router>
    </AuthProvider>
  );
}

export default App;
